import { render, staticRenderFns } from "./Programacao.vue?vue&type=template&id=2aca31f0&"
import script from "./Programacao.vue?vue&type=script&lang=js&"
export * from "./Programacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports